<template>
  <div>
    <!-- 词频echarts区域 -->
    <div
      class="wordFrequency"
      id="wordFrequency"
      v-loading="loading"
      element-loading-background="rgba(16,164,178, 0.2)"
    >
      <div class="wordFrequencyOne" id="effect_word"></div>
      <div class="wordFrequencyOne" id="effect_xing"></div>
      <div class="wordFrequencyOne" id="effect_ming"></div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      loading: false,
      // 名词
      effect_ming: [],
      effect_mingnumber: [],
      //  动词
      effect_dong: [],
      effect_dongmunber: [],
      // 形容词
      effect_xing: [],
      effect_xingnumber: [],
    };
  },
  props: ["analyze"],
  components: {},
  computed: {},
  beforeMount() {},
  mounted() {
    this.wordFrequency();
  },
  methods: {
    async wordFrequency() {
      this.loading = true;
      let data = { content: this.analyze };
      const { data: res } = await this.$http.post("/nlpir/wordFrequency", data);
      // console.log(res);
      this.loading = false;
      // 名词
      let dataWord = res.nlistWord;
      let Arrming = dataWord.slice(0, 9);
      this.ming = Arrming;
      let datanumber = res.nlistCount;
      let Arrmingnumber = datanumber.slice(0, 9);
      this.effect_mingnumber = Arrmingnumber;
      // 动词
      let dataDong = res.vlistWord;
      let dataDongnumber = res.vlistCount;
      let Arrdong = dataDong.slice(0, 9);
      let Arrdongnumber = dataDongnumber.slice(0, 9);
      this.effect_dong = Arrdong;
      this.effect_dongmunber = Arrdongnumber;

      // 形容词
      let dataXingrong = res.alistWord;
      let dataXingrongnumber = res.alistCount;
      let Arrrong = dataXingrong.slice(0, 9);
      let Arrrongnumber = dataXingrongnumber.slice(0, 9);
      this.effect_xing = Arrrong;
      this.effect_xingnumber = Arrrongnumber;

      // 启动echarts
      this.effectword();
      this.effectdong();
      this.effectxing();
    },

    effectword() {
      var myChart = echarts.init(document.getElementById("effect_word"));
      let option = {
        // backgroundColor: "#153589",
        title: {
          text: "名词",
          subtext: "",
          // left: "center",
          textStyle: {
            fontSize: 16,
            fontFamily: "Microsoft YaHei",
            color: "#fff", // 主标题文字颜色
          },
        },
        tooltip: {
          trigger: "axis",
        },

        toolbox: {
          show: true,
          feature: {
            dataView: {
              show: true,
              readOnly: false,
            },
            restore: {
              show: true,
            },
            saveAsImage: {
              show: true,
            },
          },
        },
        calculable: true,
        yAxis: [
          {
            axisLine: {
              lineStyle: {
                type: "solid",
                color: "#fff",
                width: "2",
              },
            },
            type: "category",
            data: this.ming,
          },
        ],
        xAxis: [
          {
            axisLine: {
              lineStyle: {
                type: "solid",
                color: "#fff",
                width: "2",
              },
            },
            type: "value",
            name: "",
            //position: 'top',
            max: 10,
          },
        ],
        series: [
          {
            name: "词频统计数",
            type: "bar",
            itemStyle: {
              normal: {
                //好，这里就是重头戏了，定义一个list，然后根据所以取得不同的值，这样就实现了，
                color: function (params) {
                  // build a color map as your need.
                  var colorList = [
                    "#C1232B",
                    "#B5C334",
                    "#FCCE10",
                    "#E87C25",
                    "#27727B",
                    "#FE8463",
                    "#9BCA63",
                    "#FAD860",
                    "#F3A43B",
                    "#60C0DD",
                  ];
                  return colorList[params.dataIndex];
                },
              },
            },
            barWidth: 15,
            data: this.effect_mingnumber,
          },
        ],
      };
      myChart.setOption(option);
      window.onresize = function () {
        myChart.resize();
      };
    },
    effectdong() {
      var myChart = echarts.init(document.getElementById("effect_xing"));
      let option = {
        // backgroundColor: "#153589",
        title: {
          text: "动词",
          subtext: "",
          // left: "center",
          textStyle: {
            fontSize: 16,
            fontFamily: "Microsoft YaHei",
            color: "#fff", // 主标题文字颜色
          },
        },
        tooltip: {
          trigger: "axis",
        },

        toolbox: {
          show: true,
          feature: {
            dataView: {
              show: true,
              readOnly: false,
            },
            /*magicType: {
            show: true,
            type: ['line', 'bar']
            },*/
            restore: {
              show: true,
            },
            saveAsImage: {
              show: true,
            },
          },
        },
        calculable: true,
        yAxis: [
          {
            axisLine: {
              lineStyle: {
                type: "solid",
                color: "#fff",
                width: "2",
              },
            },
            type: "category",
            data: this.effect_dong,
          },
        ],
        xAxis: [
          {
            axisLine: {
              lineStyle: {
                type: "solid",
                color: "#fff",
                width: "2",
              },
            },
            type: "value",
            name: "",
            //position: 'top',
            max: 10,
          },
        ],
        series: [
          {
            name: "词频统计数",
            type: "bar",
            itemStyle: {
              normal: {
                //好，这里就是重头戏了，定义一个list，然后根据所以取得不同的值，这样就实现了，
                color: function (params) {
                  // build a color map as your need.
                  var colorList = [
                    "#C1232B",
                    "#B5C334",
                    "#FCCE10",
                    "#E87C25",
                    "#27727B",
                    "#FE8463",
                    "#9BCA63",
                    "#FAD860",
                    "#F3A43B",
                    "#60C0DD",
                  ];
                  return colorList[params.dataIndex];
                },
              },
            },
            barWidth: 15,
            data: this.effect_dongmunber,
          },
        ],
      };
      myChart.setOption(option);
      window.onresize = function () {
        myChart.resize();
      };
    },
    effectxing() {
      var myChart = echarts.init(document.getElementById("effect_ming"));
      let option = {
        // backgroundColor: "#153589",
        title: {
          text: "形容词",
          subtext: "",
          // left: "center",
          textStyle: {
            fontSize: 16,
            fontFamily: "Microsoft YaHei",
            color: "#fff", // 主标题文字颜色
          },
        },
        tooltip: {
          trigger: "axis",
        },

        toolbox: {
          show: true,
          feature: {
            dataView: {
              show: true,
              readOnly: false,
            },
            /*magicType: {
            show: true,
            type: ['line', 'bar']
            },*/
            restore: {
              show: true,
            },
            saveAsImage: {
              show: true,
            },
          },
        },
        calculable: true,
        yAxis: [
          {
            type: "category",
            axisLine: {
              lineStyle: {
                type: "solid",
                color: "#fff",
                width: "2",
              },
            },
            data: this.effect_xing,
          },
        ],
        xAxis: [
          {
            axisLine: {
              lineStyle: {
                type: "solid",
                color: "#fff",
                width: "2",
              },
            },
            type: "value",
            name: "",
            //position: 'top',
            max: 10,
          },
        ],
        series: [
          {
            name: "词频统计数",
            type: "bar",
            itemStyle: {
              normal: {
                //好，这里就是重头戏了，定义一个list，然后根据所以取得不同的值，这样就实现了，
                color: function (params) {
                  // build a color map as your need.
                  var colorList = [
                    "#27727B",
                    "#FE8463",
                    "#9BCA63",
                    "#FAD860",
                    "#F3A43B",
                    "#60C0DD",
                    "#D7504B",
                    "#C6E579",
                    "#F4E001",
                    "#F0805A",
                    "#26C0C0",
                  ];
                  return colorList[params.dataIndex];
                },
              },
            },
            barWidth: 15,
            data: this.effect_xingnumber,
          },
        ],
      };
      myChart.setOption(option);
      window.onresize = function () {
        myChart.resize();
      };
    },
  },
  watch: {},
};
</script>
<style lang="less" scoped>
.wordFrequency {
  width: 95%;
  height: 370px;
  margin: 10px 0px 0px 30px;
  box-sizing: border-box;
  /* float: left; */
  .wordFrequencyOne {
    width: 33.3%;
    height: 340px;
    box-sizing: border-box;
    float: left;
  }
}
</style>
